import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=6e85be04&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/setting.css?vue&type=style&index=0&id=6e85be04&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e85be04",
  null
  
)

export default component.exports